// extracted by mini-css-extract-plugin
var _1 = "SymbolCounter-moduleSymbolCounter__Rvvz_";
var _2 = "SymbolCounter-modulelimitReached__t7ULY";
export { _1 as "SymbolCounter", _2 as "limitReached" }
